import { GetterTree } from 'vuex';
import { State }      from '@/views/heat-map-configuration/heat-map-configuration.types';
import { RootState }  from '@/store/store.types';

const getters: GetterTree<State, RootState> = {};

export default getters;
